<template>
    <div class="userData">
        <div class="fl">
            <img class="userImg fl" v-if="userData.sponsorAvatar" :src="userData.sponsorAvatar" alt="">
            <img v-else style="background:#272740" class="userImg fl" src="../../../../assets/images/logo_icon.png" alt="">
            <div class="fl">
                <div class="usreName" v-if="userData.sponsorName">{{userData.sponsorName}}</div>
                <div class="usreName" :class="{yxName: !userData.sponsorName}">{{userData.userName}}</div>
            </div>
        </div>
        <el-button type="primary" class="fr home" v-if="platform == 1" @click="joinUnionDialogState = true">我的主页</el-button>
        <el-dialog title="我的主页" width="480px" append-to-body :visible.sync="joinUnionDialogState" :close-on-click-modal="false" :show-close="false">
            <div class="joinImgBox">
                <img :src="imgUrl" alt="">
            </div>
            <p class="t">请用微信扫二维码进行访问或者鼠标右键保存图片使用</p>
            <div slot="footer" style="text-align: center">
                <el-button type="primary" size="small" @click="downloadImg">下载二维码</el-button>
                <el-button type="primary" size="small" @click="joinUnionDialogState = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { prefix } from '@/api';
import axios from 'axios';
export default {
    props: ['userData', 'platform'],
    data() {
        return {
            imgUrl: null,
            joinUnionDialogState: false
        }
    },
    created() {
        if(this.platform == 1) {
            axios({
                method: 'get',
                url: `${prefix}/admin/home/home_data/qr_code`,
            }).then(res => {
                this.imgUrl = res.result.url
            })
        }
    },
    methods: {
        img(d) {
            var binary = '';
            var bytes = new Uint8Array(d);
            for (var len = bytes.byteLength, i = 0; i < len; i++) {                
                binary += String.fromCharCode(bytes[i]);            
            }
            console.log(binary)
        },
        downloadImg() {
            window.open(this.imgUrl)
        }
    }
}
</script>

<style lang="scss" scoped>
 .userData {
    overflow: hidden;
    margin-bottom: 24px;
    .userImg {
        border-radius: 50%;
        width: 50px;
        height: 50px;
        margin-right: 18px;
    }
    .usreName {
        font-size: 14px;
        line-height: 25px;
    }
    .yxName{
        line-height: 50px;
    }
    .home{
        line-height: 30px;
        padding: 0;
        margin-top: 10px;
        border: none;
        width: 100px
    }
    .fl{
        float: left;
    }
    .fr{
        float: right;
    }
}
.joinImgBox{
    width: 160px;
    height: 160px;
    margin: 10px auto;
    img{
        width: 100%;
        height: 100%;
        display: block;
    }
}
.t{
    text-align: center
}
</style>
